import { enrichConvertersRegistry } from '../../utils/convertersRegistry'
import { shadowConverterMap } from './shadowPropsToCss'

/**
 * Enriches the converters registry with all Shadow style property converters.
 * Shadow converters handle CSS box-shadow and text-shadow properties.
 */
export function enrichShadowConverters(): void {
	// Register all shadow converters
	Object.entries(shadowConverterMap).forEach(([key, converter]) => {
		enrichConvertersRegistry(key, converter)
	})
}
